import React, { useEffect, useState } from 'react';
import '../App.css';
import {Link} from "react-router-dom";
import DownIcon from "../assets/images/downicon.png"
import DownIconWhite from "../assets/images/downiconwhite.png"
import BlahBlah from "../assets/images/blahblah.png"
import Nopic from "../assets/images/nopic.png"
import Footer from '../components/footer';



export default function BeforeSignUp(){

    const [show1, setShow1] = useState(false)
    const [show2, setShow2] = useState(false)
    const [show3, setShow3] = useState(false)
    const [a,setA] = useState(0)

    function checka(event)
    {
        var checkbox = document.getElementById(event.target.id);
        if (checkbox.checked)
        {
            setA(a+1)
        } 
        if (checkbox.checked===false)
        {
            setA(a-1)
        }
    }

    return(
       <div class="w-full overflow-hidden sm:w-1/3">
           <div class="w-full mt-4 flex justify-around">
               <div>
                <p class="float-left w-6/12">Already registered?</p>
               
               <Link class="float-left w-5/12 rounded mt-2 h-8 bg-blue-700" to="/signIn">
               <div class="w-full text-white mt-0.5 text-center font-light">
                   <p class="">Sign In</p>
               </div>
               </Link>
               </div>
           </div>
           <div class="w-full mt-8 px-6 font-light text-2xl">
               <p class="">Currently, the</p>
               <p class="">app only</p>
               <p class="">contains</p>
               <p class="text-blue-800">chinese</p>
               <p class=""><span class="text-pink-500">whispers</span> for</p>
               <p class="">ideas</p>
           </div>
           <div class="bg-[#00FFF0] mt-8 p-4">
               <div>
                   <div class="flex mb-8 "><img class="w-10/12 m-auto" src={BlahBlah} alt="none"/></div>
                   <div class="flex my-3"><img onClick={()=>setShow1(!show1)} class="m-auto" src={DownIcon} alt="none"/></div>    
                </div>
               {show1&&<div>
                   <div class="mb-4">Before you get started!<br/>Leave what you think this chinese whisper of ideas might be?</div>
                   <textarea class="w-full p-3 h-32" placeholder="type here..."/>
                  <div class="flex my-3"> <button class="m-auto bg-orange-600 py-2 px-4 rounded-xl shadow-xl text-white">SURPRISE IF YOU SUBMIT</button> </div>
                   
                </div>
                }
            </div>
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12"><p class="">Scenario A.</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12 bg-pink-300 p-1 text-center rounded h-9"><p class="p-0.5">Share an Idea</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12 bg-blue-800 text-xs pt-2 text-white text-center rounded p-1 h-9"><p class="p-0.5">Others try to improve it</p></div>
           </div>
           <div class="w-full h-4"></div>
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12 h-7"><p class="p-0.5">Scenario B.</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12 p-1 text-center bg-blue-800 text-white h-9 rounded"><p class="p-0.5">Copy someone's idea</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12 text-center rounded bg-pink-300 h-9 p-1"><p class="p-0.5">Improve it</p></div>
           </div>

           <div class="w-full h-4"></div>

           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12 font-bold h-7"><p class="p-0.5">The subscription for the app is free in beta.</p></div>
           </div>

           <div class="w-full h-8"></div>
           <Link class="w-full" to="/admissible">
           <div class="w-full mt-4 flex">
                <div class="w-1/12"></div>
                <div class="w-10/12 flex flex-row justify-evenly bg-pink-500 rounded-lg text-white text-center h-16">
                        <div class="mt-3">
                            <p class="p-2">Subscribe</p>
                        </div>
                        <div class="mt-3">
                        <p class="bg-blue-800 rounded-md p-2">SIGN UP</p>
                        </div>
                    
                </div>
           </div>
           </Link>
           <div class="w-full text-sm mt-2 text-center">
           <p><span class="line-through">CANCEL ANYTIME</span>  "FREE" </p>
           </div>
           <div class="h-8"></div>
           <div class="bg-[#000000] mt-8 text-white p-4">
               <div>
                    <div class="flex mb-4"><div class="m-auto text-3xl atwo">Before Signing Up</div></div>
                    <div class="flex mb-8"><div class="w-8/12 text-lg btwo text-center">Consideration CheckList</div><div class="mt-3"><div class="rounded-xl text-black p-2 bg-white">Take</div></div></div>
                   <div class="flex my-3"><img onClick={()=>setShow2(!show2)} class="m-auto" src={DownIconWhite} alt="none"/></div>    
                </div>
               {show2&&<div class="grid-cols-1 grid justify-evenly">
                   <div class="flex flex-row gap-2">
                       <div><input onClick={(e)=>checka(e)} id="jghdjsd" class="mt-2 bg-yellow-200 w-4 h-4" type="checkbox"/></div>
                       <div>Do I have the time for this</div>
                   </div>
                   <div  class="flex flex-row gap-2">
                       <div><input onClick={(e)=>checka(e)} id="sdjkfjkd" class="mt-2 bg-yellow-200 w-4 h-4" type="checkbox"/></div>
                       <div>Will it help me in the future</div>
                   </div>
                   <div class="flex flex-row gap-2">
                       <div><input onClick={(e)=>checka(e)} id="sawasa" class="mt-2 bg-yellow-200 w-4 h-4" type="checkbox"/></div>
                       <div>Is there some learning for me</div>
                   </div>
                   <div class="flex flex-row gap-2">
                       <div><input onClick={(e)=>checka(e)} id="dsdwecew" class="mt-2 bg-yellow-200 w-4 h-4" type="checkbox"/></div>
                       <div>Is it to my liking</div>
                   </div>
                   <div class="my-6 pl-3 text-2xl">
                   {(a===1)&&<div>😭We don’t know😭</div>}
                   {a===2&&<div>😓We don’t know😓</div>}
                   {a===3&&<div>😎You should subscribe😎</div>}
                   {a===4&&<div>😇You have to subscribe😇🥳</div>}
                   </div>
                </div>
                }
            </div>
           <div class="w-full h-16"></div>
           <div class="bg-[#FAFF00] mt-8 p-4">
               <div>
                   <div class="flex"><img class="w-6/12 my-10 m-auto" src={Nopic} alt="none"/></div>
                   <div class="flex my-3"><img onClick={()=>setShow3(!show3)} class="m-auto" src={DownIcon} alt="none"/></div>    
                </div>
               {show3&&<div>
                   <div class="font-bold text-xl mt-8">Are!</div>
                   <div class="mb-4 mb-4">It’s always possible to reject some app/webapp or whatever. Post your reason of rejecting this webapp for others to consider as well</div>
                   <textarea class="w-full p-3 h-32" placeholder="type here..."/>
                  <div class="flex my-3 justify-end"> <button class=" bg-red-500 py-2 px-4 rounded-xl shadow-xl text-white">SUBMIT</button> </div>
                   
                </div>
                }
            </div>
            <div class="w-full h-16"></div>
            <Footer/>
       </div>
    )
}